import React from "react";
import styles from "./styles.module.scss";
import classNames from "classnames";
import { IconBaseProps } from "react-icons";
import { BsArrowLeft, BsArrowRight } from "react-icons/bs";
import { UIText } from "../uIKit";
import { TEXT_TAGS } from "src/utils/enums";
import { useAppSelector } from "src/hooks/useRedux";
import ScreenReaderText from "../accessibilityKit/screenReaderText";

interface LoaderProps {
  fullHeight?: boolean;
  customClassName?: any;
}

const Loader = ({ fullHeight = false, customClassName }: LoaderProps) => {
  const { strings } = useAppSelector((state) => state.app);
  return (
    <>
      {fullHeight ? (
        <div className={classNames(styles.loaderContainer, customClassName)}>
          <ScreenReaderText text={[strings.acc_t_loader_title, strings.acc_t_loader_description]} announnceDelay={1700}/>
          <div className={styles.loaderCard}>
            <div className={styles.iconContainer}>
              <div className={styles.arrows}>
                <span>
                  {React.createElement(
                    BsArrowLeft as React.ComponentType<IconBaseProps>,
                    {}
                  )}
                </span>
                <span>
                  {React.createElement(
                    BsArrowRight as React.ComponentType<IconBaseProps>,
                    {}
                  )}
                </span>
              </div>
            </div>
            <UIText
              text={strings.t_loader_title}
              tag={TEXT_TAGS.H2}
              size={32}
              weight={500}
              style={styles.title}
            />
            <UIText
              text={strings.t_loader_description}
              tag={TEXT_TAGS.SPAN}
              size={22}
              weight={400}
              style={styles.description}
            />
          </div>
        </div>
      ) : (
        <div className={styles.loaderContainerNotFull}>
          <ScreenReaderText text={strings.acc_loading_page} announnceDelay={1700}/>
          <div className={styles.loader}></div>
        </div>
      )}
    </>
  );
};

export default Loader;
